<div class="row">
  <div class="row2">
    <div class="input-group">
      
      <kendo-dropdownlist
        style="width: 12rem; flex: 0 0 12rem;"
        [data]="productCategories"
        textField="name"
        valueField="id"
        [valuePrimitive]="true"
        [value]="catalogFilter.categoryId ?? null"
        (selectionChange)="productCategoryChanged($event)"
      >
      </kendo-dropdownlist>
      <!-- Enter searches, same as the button. keyup rather than keydown: it does
           not repeat while the key is held, and it fires after an IME composition
           is confirmed rather than swallowing that Enter. -->
      <input
        type="text"
        class="form-control"
        [(ngModel)]="product"
        (keyup.enter)="emitSearch()"
        i18n-aria-label
        aria-label="Suchbegriff"
        data-testid="search-term-input"
      />

      <button
        class="btn btn-outline-secondary"
        type="button"
        id="button-addon2"
        (click)="emitSearch()"
        data-testid="search-submit-button"
        i18n
      >
        Suchen
      </button>
     
    </div>
  </div>
</div>
